import { GraphSetTypeEnum_Enum } from 'generated/graphql';

export const MAX_PARAMETERS = 20;
export const MOBILE_MAX_PARAMETERS = 5;

export enum PlotterMode {
  TIME_PERIOD = 'time-period',
  RING = 'ring',
}

export const graphSetStateVersion = 5;

export const mapGraphSetTypeToPlotterMode = {
  [GraphSetTypeEnum_Enum.Period]: PlotterMode.TIME_PERIOD,
  [GraphSetTypeEnum_Enum.Ring]: PlotterMode.RING,
};

export const mapPlotterModeToGraphSetType = {
  [PlotterMode.TIME_PERIOD]: GraphSetTypeEnum_Enum.Period,
  [PlotterMode.RING]: GraphSetTypeEnum_Enum.Ring,
};
